import { makeAuthHeaders } from "../oauth/auth";

export const fetchAccountUserProfileService = async () => {
    try {
        const headers = await makeAuthHeaders();

        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/dcm/accountUserProfile`,
            {
                method: "GET",
                headers,
            }
        );

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            const body = await response.json();
            throw new Error(body.message || "Fetch error");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};

export const fetchAccountUserProfilesByRoleIdService = async (roleId) => {
    try {
        const headers = await makeAuthHeaders();
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/dcm/accountUserProfiles?roleId=${roleId}`,
            {
                method: "GET",
                headers,
            }
        );

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}